'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;


var SectionClientService = React.createClass({

    componentDidMount() {
        this.props.logPageView();
    },

    /**
     * @return {object}
     */
    render: function () {
        return (
            <section id="section2" className="content-section text-center about-section sectionPage">
                <div className="row">
                    <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="title-v1">
                            <div className="row">
                                <div className="col-sm-12   col-xs-12">
                                    <h1 className="text-center"><FormatMessage locale={this.props.locale}
                                                                               path="menu/menuCustomerService"/></h1>
                                    <hr className="small"/>
                                </div>
                                <div className="col-sm-8 col-xs-8 col-xs-offset-2">
                                    <p><FormatMessage locale={this.props.locale}
                                                      path="customerServicePage/customerServiceDescription"/></p>
                                    <p className="font25" style={{marginTop: "20px"}}>
                                        <i className="icon-prepend fa fa-phone"></i> <a href="tel:18009262277">1-800-926-2277</a> 
                                    </p>
                                    <p className="font25">
                                        <i className="icon-prepend fa fa-envelope"></i> <a href="mailto:complaints@barri.com">
                                                complaints@barri.com
                                        </a>
                                    </p>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

})


module.exports = SectionClientService



// WEBPACK FOOTER //
// ./js/sectionClientService.js